import { render, staticRenderFns } from "./Khlb.vue?vue&type=template&id=6a95440e&"
import script from "./Khlb.vue?vue&type=script&lang=js&"
export * from "./Khlb.vue?vue&type=script&lang=js&"
import style0 from "./Khlb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports